import { memo } from 'react';
import { useSelector } from 'react-redux';
import { selectSelectedType, selectShowInvalids } from '@store/order/selectors';
import Grid from '@pages/order/patterns/Grid';
import { invalidFormValue } from '@components/utils';
import { AnimalTypeEnum } from '@api/types/AnimalTypeEnum';



interface PatternsProps {
	animalType: AnimalTypeEnum,
}


const Patterns = (props: PatternsProps): JSX.Element => {
	const { animalType } = props;

	const showInvalids = useSelector(selectShowInvalids);
	const selectedType = useSelector(selectSelectedType);

	return (
		<div className='patterns-section'>

			<label className='patterns-label'>
				Vzor <span>*</span> {showInvalids && invalidFormValue(selectedType) &&
					<p className='form-invalid'>Povinné pole</p>}
			</label>

			<Grid animalType={animalType} />
			
		</div>
	);
};

export default memo(Patterns);